import { useCookies } from 'react-cookie';

import { SELECTED_SSO_SLUG_COOKIE } from '@framework/utils/cookies';
import { getSelectedSSOSlug } from '@framework/utils/url';

type UseGetSSOSlugReturn = [string, () => void];

const useGetSSOSlug = (): UseGetSSOSlugReturn => {
    const [cookies, , removeCookie] = useCookies([SELECTED_SSO_SLUG_COOKIE]);
    const selectedSSOSlugCookie = cookies[SELECTED_SSO_SLUG_COOKIE];
    const ssoSlugQueryParam: string | null = getSelectedSSOSlug();
    const ssoSlug = (ssoSlugQueryParam ?? selectedSSOSlugCookie) as string;

    const handleRemoveSlugCookie = () => {
        removeCookie(SELECTED_SSO_SLUG_COOKIE);
    };

    return [ssoSlug, handleRemoveSlugCookie];
};

export default useGetSSOSlug;
